import React from 'react';
import { CTAButton, CHECKOUT_URL } from './CTAButton';
import { TodayOfferCard } from './TodayOfferCard';
const sampleBuilds = ['Balloon-Powered Race Car', 'Bottle Cap Spinning Top', 'Popsicle Stick Catapult', 'Balance Bird', 'Clothespin Grabber Claw'];
export function CardPreview() {
  return <div className="mt-6 sm:mt-8" data-id="element-37" data-mp="2du9ffm04rlmj">
      <div className="mb-8 flex flex-col items-center text-center" data-id="element-38" data-mp="2dr53u3kc5nlu">
        <span className="text-xs font-bold uppercase tracking-widest text-blue-deep" data-id="element-39" data-mp="1q4f458vgm54e">
          A look inside a build card
        </span>
        <h3 className="mt-2 font-serif-display text-2xl font-bold leading-tight text-navy sm:text-3xl" data-id="element-40" data-mp="1l2g2q4ja5ia3">
          One card. <span className="text-blue" data-id="element-41" data-mp="1v2qfxp5bepp9">One clear next adventure.</span>
        </h3>
        <p className="mt-3 text-sm leading-relaxed text-navy/75 sm:text-base" data-id="element-42" data-mp="1v0ngyfm6pm8e">
          Every build card tells you what to gather, how long it takes, the difficulty, whether
          adult help is needed, how to build it, why it works, and what to try next.
        </p>

        <div className="mt-6 w-full overflow-hidden rounded-xl border border-blue/15 bg-ivory shadow-sm" data-id="element-43" data-mp="papboh0wf78">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/beea1f22-1e01-4ab1-af5d-4d3704cf7237.jpg" alt="Five printed build cards fanned out with bottle caps, popsicle sticks, a clothespin and a balloon beside them" loading="lazy" className="block aspect-[4/3] w-full object-cover" data-id="element-44" data-mp="4pkux00wl3lk" />
        </div>

        <ul className="mt-5 flex flex-wrap justify-center gap-2" data-id="element-45" data-mp="3hyyywcz7bqnk">
          {sampleBuilds.map(build => <li key={build} className="rounded-full bg-blueprint px-3 py-1 text-xs font-semibold text-blue-deep" data-id="element-46" data-mp="3mw916t7ovwst">
              {build}
            </li>)}
        </ul>
      </div>

      <CTAButton label="GET THE FULL INVENTOR LAB" href={CHECKOUT_URL} external data-id="element-47" data-mp="128w00h5pnz7d" />
      <TodayOfferCard data-id="element-48" data-mp="1741kdbjgt5tc" />
      <div className="mt-4 rounded-xl border border-blue/15 bg-blueprint px-4 py-3 text-center" data-id="element-49" data-mp="177pheko4cact">
        <p className="text-sm font-bold text-blue-deep" data-id="element-50" data-mp="hjk1hm22iryi">🔒 Secure checkout</p>
        <p className="mt-1 text-xs leading-relaxed text-navy/70 sm:text-sm" data-id="element-51" data-mp="cie61gh0wqla">
          All major credit and debit cards accepted. Your $27 payment is processed securely.
        </p>
      </div>
    </div>;
}